import React from 'react';

import TextStyleIcon from '@atlaskit/icon/core/text-style';

export const EditorTextColorIcon = (): React.JSX.Element => {
	return <TextStyleIcon label="" spacing="spacious" />;
};
